import { Input, Select } from "antd";
import { useMemo } from "react";
import styles from "./index.module.less";

export const list = [
  {
    value: "ZHReg",
    label: "身份证",
    placeholder: "必填项，例如：350201199001234567",
  },
  {
    value: "HKReg",
    label: "港澳通行证",
    placeholder: "必填项，例如：H12345678",
  },
  {
    value: "TWReg",
    label: "台湾通行证",
    placeholder: "必填项，例如：12345678",
  },
  {
    value: "passportReg",
    label: "护照",
    placeholder: "必填项，例如：a12345678",
  },
];

export default function IdentityInput(props) {
  const { onChange, identityType, setIdentityType, value } = props;
  const placeholder = useMemo(() => {
    return list.find((item) => item.value === identityType).placeholder;
  }, [identityType]);

  return (
    <Input.Group compact className={styles.inputGroup}>
      <Select
        value={identityType}
        className={styles.select}
        options={list}
        onChange={(value) => {
          setIdentityType(value);
          onChange("");
        }}
        dropdownClassName={styles.dropdown}
        getPopupContainer={(triggerNode) => {
          return triggerNode.parentNode.parentNode;
        }}
        // showArrow={false}
      ></Select>
      <Input
        className={styles.input}
        onChange={(e) => onChange(e.target.value)}
        placeholder={placeholder}
        value={value}
      />
    </Input.Group>
  );
}
